const translations = {
  "en": {
    "All fixable — let's take them one at a time.": "All fixable — let's take them one at a time.",
    "Build my plan to fix these": "Build my plan to fix these",
    "risks are quietly costing you.": "risks are quietly costing you."
  },
  "zh-tw": {
    "All fixable — let's take them one at a time.": "所有問題皆可修正 — 我們逐一為您處理。",
    "Build my plan to fix these": "建立計畫修正這些問題",
    "risks are quietly costing you.": "風險正悄悄侵蝕您的資產。"
  }
};

export default translations;
